export default __webpack_public_path__ + "static/media/info.5db63c84.svg";